<div class="everything-about-cat">

    <div class="container cat-23-cotnainer">
        <div class="row justify-content-center">
            <div class="col-md-10">
                <div class="row">
                    <div class="col-md-4 col-4-custom">
                        <div class="everything-menu sticky-top">
                        </div>
                    </div>

                    <div class="col-md-8 col-8-custom m-0 p-0">
                        <div id="tab-everything-about-CAT" class=" everything-content">
                            <div class="header-sec">
                                <h2>Everything about CAT 2025</h2>
                                <p>How to Start your preparation</p>
                            </div>
                            <mat-accordion>
                                <mat-expansion-panel>
                                    <mat-expansion-panel-header [collapsedHeight]="'100px'" [expandedHeight]="'100px'">
                                        <mat-panel-title>
                                            <div class="exp-header">
                                                <div class="img">
                                                    <img src="https://media.iquanta.in/ui_images/icon-2023-1.png"
                                                        alt="">
                                                </div>

                                                <div class="text middle">
                                                    <h6>What is MBA?</h6>
                                                    <p>Know everything about MBA</p>
                                                </div>
                                            </div>
                                        </mat-panel-title>

                                    </mat-expansion-panel-header>
                                    <div class="img">
                                        <img src="https://media.iquanta.in/ui_images/what-mba-mobile.jpg"
                                            alt="">
                                    </div>
                                </mat-expansion-panel>

                                <mat-expansion-panel expanded="true">
                                    <mat-expansion-panel-header [collapsedHeight]="'100px'" [expandedHeight]="'100px'">
                                        <mat-panel-title>
                                            <div class="exp-header">
                                                <div class="img">
                                                    <img src="https://media.iquanta.in/ui_images/icon-2023-2.png"
                                                        alt="">
                                                </div>

                                                <div class="text middle">
                                                    <h6>What is CAT?</h6>
                                                    <p>CAT Exam is the national-level management</p>
                                                </div>
                                            </div>
                                        </mat-panel-title>

                                    </mat-expansion-panel-header>
                                    <div class="img">
                                        <img src="https://media.iquanta.in/ui_images/what-cat-mobile.jpg"
                                            alt="">
                                    </div>
                                </mat-expansion-panel>

                                <mat-expansion-panel>
                                    <mat-expansion-panel-header [collapsedHeight]="'100px'" [expandedHeight]="'100px'">
                                        <mat-panel-title>
                                            <div class="exp-header">
                                                <div class="img">
                                                    <img src="https://media.iquanta.in/ui_images/icon-2023-3.png"
                                                        alt="">
                                                </div>

                                                <div class="text middle">
                                                    <h6>CAT Exam Pattern</h6>
                                                    <p>Pattern you must know</p>
                                                </div>
                                            </div>
                                        </mat-panel-title>

                                    </mat-expansion-panel-header>
                                    <div class="img">
                                        <img src="https://media.iquanta.in/ui_images/exam-pattern.jpg"
                                            alt="">
                                    </div>
                                </mat-expansion-panel>

                                <mat-expansion-panel>
                                    <mat-expansion-panel-header [collapsedHeight]="'100px'" [expandedHeight]="'100px'">
                                        <mat-panel-title>
                                            <div class="exp-header">
                                                <div class="img">
                                                    <img src="https://media.iquanta.in/ui_images/icon-2023-4.png"
                                                        alt="">
                                                </div>

                                                <div class="text middle">
                                                    <h6>CAT Important Dates</h6>
                                                    <p>Total amount of mental effort that is required to complete a task
                                                    </p>
                                                </div>
                                            </div>
                                        </mat-panel-title>

                                    </mat-expansion-panel-header>
                                    <div class="img">
                                        <img src="https://media.iquanta.in/ui_images/CAT-important-dates.jpg"
                                            alt="">
                                    </div>
                                </mat-expansion-panel>

                                <mat-expansion-panel>
                                    <mat-expansion-panel-header [collapsedHeight]="'100px'" [expandedHeight]="'100px'">
                                        <mat-panel-title>
                                            <div class="exp-header">
                                                <div class="img">
                                                    <img src="https://media.iquanta.in/ui_images/icon-2023-5.png"
                                                        alt="">
                                                </div>

                                                <div class="text middle">
                                                    <h6>CAT Eligibility</h6>
                                                    <p>Bachelor's Degree from a recognized University with 50%</p>
                                                </div>
                                            </div>
                                        </mat-panel-title>

                                    </mat-expansion-panel-header>
                                    <div class="img">
                                        <img src="https://media.iquanta.in/ui_images/CAT-eligibility.jpg"
                                            alt="">
                                    </div>
                                </mat-expansion-panel>

                                <mat-expansion-panel>
                                    <mat-expansion-panel-header [collapsedHeight]="'100px'" [expandedHeight]="'100px'">
                                        <mat-panel-title>
                                            <div class="exp-header">
                                                <div class="img">
                                                    <img src="https://media.iquanta.in/ui_images/icon-2023-5.png"
                                                        alt="">
                                                </div>

                                                <div class="text middle">
                                                    <h6>CAT Past Papers</h6>
                                                    <p>This page has all Past CAT Papers only, with detailed solutions
                                                        in all required format.</p>
                                                </div>
                                            </div>
                                        </mat-panel-title>

                                    </mat-expansion-panel-header>
                                    <div class="img">
                                        <img src="https://media.iquanta.in/ui_images/CAT-past-papers-mobile.jpg"
                                            alt="">
                                    </div>
                                </mat-expansion-panel>

                            </mat-accordion>
                        </div>

                        <div class="courseBtn" (click)="gotocourses()">
                            <button mat-button>View Courses</button>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="everything-about-cat-desk">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <h2>Everything about CAT 2025</h2>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-10">
                <mat-tab-group mat-align-tabs="center" [selectedIndex]="selectedIndex" class="cat_twe">
                    <mat-tab label="What is MBA?">
                        <div class="about-cat-wrapper">
                            <!-- <div class="img">
                                <img src="https://media.iquanta.in/ui_images/what-mba-desk.jpg"
                                    alt="">
                            </div> -->
                            <div class="tab-content">
                                <div class="top-logo">
                                    <img src="https://media.iquanta.in/ui_images/logo2.png" alt="">
                                </div>
                                <div class="row">
                                    <div class="col-md-2">
                                        <div class="left">
                                            <h2>01</h2>
                                        </div>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="row">
                                            <div class="right">
                                                <h3>What is an MBA?</h3>
                                                <p>MBA or Masters of Business Administration is a Postgraduate degree highly valued in the market. An MBA programme aims to impart a holistic knowledge in the field of Management under Finance, Marketing, Human Resources, Operations and several other domains.</p>
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="contennt">
                                        <h3>Why MBA?</h3>
                                        <div class="img">
                                            <img src="https://media.iquanta.in/ui_images/chart.png" alt="">
                                        </div>
    
                                        <ul>
                                            <li>Industry Knowledge</li>
                                            <li>Higher Earnings</li>
                                            <li>Personality Development</li>
                                            <li>Better Job Profile</li>
                                            <li>Networking</li>
                                            <li>Career Switch</li>
                                        </ul>
                                    </div>
                                </div>
                            
                               
                            </div>
                        </div>
                      </mat-tab>
                    <mat-tab label="What is CAT?">
                        <div class="about-cat-wrapper">
                            <!-- <div class="img">
                                <img src="https://media.iquanta.in/ui_images/what-cat.jpg"
                                    alt="">
                            </div> -->

                              <div class="tab-content">
                                <div class="top-logo">
                                    <img src="https://media.iquanta.in/ui_images/logo2.png" alt="">
                                </div>
                                <div class="row">
                                    <div class="col-md-2">
                                        <div class="left">
                                            <h2>02</h2>
                                        </div>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="row">
                                            <div class="right">
                                                <h3>Common Admission Test (CAT)</h3>
                                               
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="con-left">
                                                    <h6>Conducting Boady:</h6>
                                                    <div class="top-box">
                                                        <h3>Top IIMS</h3>
                                                        <p>(On a rotationl basics)</p>
                                                        <ul>
                                                            <li>2022: IIM Bangalore</li>
                                                            <li>2021: IIM Ahmedabad</li>
                                                            <li>2020: IIM Indore</li>
                                                            <li>2019: IIM Kozhikode</li>
                                                            <li>2018: IIM Calcutta</li>
                                                            <li>2017: IIM Lucknow</li>
                                                            <li>2016: IIM Bangalore</li>
                                                            <li>2015: IIM Ahmedabad</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-8">
                                                <div class="con-right">
                                                    <h6>Institutes Accepting CAT Score:</h6>
                                                    <div class="top-box">
                                                        <h3>20 IIMS, FMS, MDI, SPJIMR &1200+ other B-schools.</h3>
                                                    </div>
                                                    <div class="top-box2">
                                                       <div class="row">
                                                        <div class="col-md-6">
                                                            <h3>B-Schools Packages</h3>
                                                            <ul>
                                                                <li>IIM Bangalore : 36.2 LPA</li>
                                                                <li>IIM Ahmedabad: 33.82 LPA</li>
                                                                <li>IIM Calcutta :34.2 LPA</li>
                                                                <li>IIM Lucknow : 31.03 LPA</li>
                                                                
                                                            </ul>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="table-div">
                                                                <table style="width:100%">
                                                                  <tr>
                                                                    <td colspan="3" >GENERAL PACKAGES </td>
                                                                    
                                                                    
                                                                  </tr>
                                                                  <tr>
                                                                    <td > TOP 20 B-Schools</td>
                                                                    <td >25+ LPA</td>
                                                                    
                                                                  </tr>
                                                                  <tr>
                                                                    <td > TOP 30 B-Schools</td>
                                                                    <td >20+ LPA</td>
                                                                    
                                                                  </tr>
                                                                  <tr>
                                                                    <td > TOP 40 B-Schools</td>
                                                                    <td >15+ LPA</td>
                                                                    
                                                                  </tr>
                                                                  
                                                                </table>
                                                              </div>
                                                        </div>
                                                       </div>
                                                    </div>
                                                </div>
                                            
                                            </div>
                                           
                                        </div>

                                        <div class="row">
                                            <div class="images">
                                                <ul>
                                                    <li><div class="img" style="    height: 15vh; overflow: hidden; border-radius: 20px; margin-bottom: 7px;"><img src="https://www.iquanta.in/blog/wp-content/uploads/2024/09/bs7-66e2d41214a60.webp" alt=""></div><span>IIM Ahmedabad</span></li>
                                                    <li><div class="img" style="    height: 15vh; overflow: hidden; border-radius: 20px; margin-bottom: 7px;"><img src="https://www.iquanta.in/blog/wp-content/uploads/2024/09/bs3-66e2d41094645.webp" alt=""></div><span>IIM Bangalore</span></li>
                                                    <li><div class="img" style="    height: 15vh; overflow: hidden; border-radius: 20px; margin-bottom: 7px;"><img src="https://www.iquanta.in/blog/wp-content/uploads/2024/09/bs1-66e2d41096266.webp" alt=""></div><span>IIM Calcutta</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                             
                            
                               
                            </div>
                       
                        </div>
                    </mat-tab>
                    <mat-tab label="CAT Exam Pattern">
                        <div class="about-cat-wrapper">
                            <!-- <div class="img">
                                <img src="https://media.iquanta.in/ui_images/cat-exam-pattern.jpg"
                                    alt="">
                            </div> -->
                            <div class="tab-content">
                                <div class="top-logo">
                                    <img src="https://media.iquanta.in/ui_images/logo2.png" alt="">
                                </div>
                                <div class="row" style="display: flex; align-items: center;">
                                    <div class="col-md-2">
                                        <div class="left">
                                            <h2>03</h2>
                                        </div>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="row">
                                            <div class="right">
                                                <h3>CAT EXAM PATTERN</h3>
                                                <p>The CAT Exam is divided into 3 sections, spanning 40 minutes each, making it a 2-hour exam</p>
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>

                                <div class="row justify-content-center">
                                    <div class="col-md-8">
                                        <div class="row">
                                            <div class="col-md-8">
                                                <div class="subject">
                                                    <h6>subject</h6>
                                                    <ul>
                                                        <li>quantitative ability</li>
                                                        <li>verbal ability & reading comprehension</li>
                                                        <li>logical reasoning & data interpretaton</li>
                                                    </ul>
                                                    <h5>total</h5>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="row">
                                                <div class="col-md-6">
                                                    <div class="subject qustions">
                                                        <h6>questions</h6>
                                                        <ul>
                                                            <li>22</li>
                                                            <li>24</li>
                                                            <li>20</li>
                                                        </ul>
                                                        <h5>66</h5>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="subject qustions qustions1 ">
                                                        <h6>time</h6>
                                                        <ul>
                                                            <li>40 <p>minutes</p></li>
                                                            <li>40<p>minutes</p></li>
                                                            <li>40<p>minutes</p></li>
                                                        </ul>
                                                        <h5>120
                                                            <span>minutes</span>
                                                        </h5>
                                                    </div>
                                                </div>
                                              </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="botton-text">
                                                <h6>Question Type: <span>Objective (80%) & TITA (20%)</span> </h6>
                                                    <h6>MARLING SCHEME : <span>+3 for every correct answer | -1 for every incorrect answer</span> </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                               
                            
                               
                            </div>

                        </div>
                    </mat-tab>
                    <mat-tab label="CAT Important Dates">
                        <div class="about-cat-wrapper">
                            <!-- <div class="img">
                                <img src="https://media.iquanta.in/ui_images/2024+Important+dates.png"
                                    alt="">
                            </div> -->
                            <div class="tab-content">
                                <div class="top-logo">
                                    <img src="https://media.iquanta.in/ui_images/logo2.png" alt="">
                                </div>
                                <div class="row" style="display: flex; align-items: center;">
                                    <div class="col-md-2">
                                        <div class="left">
                                            <h2>04</h2>
                                        </div>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="row">
                                            <div class="right">
                                                <h3>CAT 2025 <BR> IMPORTANT DATES</h3>
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-md-9">
                                        <div class=" dates-table">
                                            <table style="width:100%">
                                              <tr>
                                                <td ><span>EVENTS</span></td>
                                                <td ><span>CAT 2025 DATES</span></td>
                                                
                                              </tr>
                                              <tr>
                                                <td > CAT 2025 Notification Release</td>
                                                <td > 4th Week of Julay</td>
                                                
                                              </tr>
                                              <tr>
                                                <td > CAT 2025 Application Process Starts</td>
                                                <td >1st Week of August 2025</td>
                                                
                                              </tr>
                                              <tr>
                                                <td > Last Date To Fill CAT 2025 Application Form</td>
                                                <td >2nd Week of September 2025</td>
                                                
                                              </tr>
                                              <tr>
                                                <td>Last Date To Submit the Application Fee</td>
                                                <td>2nd Week of September 2025</td>
                                              </tr>
                                              <tr>
                                                <td>CAT 2025 Admit Card Release</td>
                                                <td>4th Week of October 2025</td>
                                              </tr>
                                              <tr>
                                                <td>CAT 2025 Exam date</td>
                                                <td>4th Week of November 2025</td>
                                              </tr>
                                              <tr>
                                                <td>CAT 2025 Result</td>
                                                <td>1st Week of January</td>
                                              </tr>
                                              
                                            </table>
                                          </div>
                                    </div>
                                </div>
                               
                            
                               
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="CAT Eligibility">
                        <div class="about-cat-wrapper">
                            <!-- <div class="img">
                                <img src="https://media.iquanta.in/ui_images/CAT-eligibility-desk.jpg"
                                    alt="">
                            </div> -->
                            <div class="tab-content">
                                <div class="top-logo">
                                    <img src="https://media.iquanta.in/ui_images/logo2.png" alt="">
                                </div>
                                <div class="row" style="display: flex; align-items: center;">
                                    <div class="col-md-2">
                                        <div class="left">
                                            <h2>05</h2>
                                        </div>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="row">
                                            <div class="right">
                                                <h3>CAT ELIGIBILITY</h3>
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-md-8">
                                        <div class="eligibility">
                                            <p>Required minimum gradution score to appear in CAT</p>
                                            <h3><span>50%</span> For General/OBC</h3>
                                            <h3><span>45%</span>For SC/ST/PwD candidates</h3>
                                            <ul>
                                                <li>Final year bachelor's degree candidates or those awaiting their result are also eligible to appear for the CAT exam.</li>
                                                <li>Candidates with profeessional qualification such as CA/CS/ICWA can also appear foe CAT.</li>
                                                <li>10th or 12th scores do not affect the CAT Eligibility</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            
                            
                               
                            </div>

                        </div>
                    </mat-tab>
                    <mat-tab label="CAT Past Papers">
                        <div class="about-cat-wrapper">
                           <!-- 
                            <div class="img">
                                <img src="https://media.iquanta.in/ui_images/cat-previous.jpeg"
                                    alt="">
                            </div> -->
                           <div class="tab-content">
                            <div class="past-papers">
                                <h3>CAT PAST PAPERS</h3>
                                <p>MBA or Masters of Business Administration is Postgraduate degree highly valued in the market. This page has all Past CAT Papers only, with detailed solutions in all required format.</p>
                                <ul>
                                    <li>Topic-wise Past CAT Questions</li>
                                    <li>Year-wise Past CAT Questions</li>
                                    <li>Take Past CAT as a Mock</li>
                                </ul>
                                <button mat-raised-button [routerLink]="['/test/cat-previous-papers']"  > check now</button>
                                
                            </div>
                           </div>

                        </div>
                    </mat-tab>
                </mat-tab-group>
                
                <div class="courseBtn" *ngIf="pageType == 'patna'" (click)="gotocourses()">
                    <button mat-button>CAT Courses</button>
                </div>

            </div>
        </div>


    </div>
</div>   